import { get } from "@/utils/request";
import env from "@/env";
import { PagingParameters, WithPagingData } from "./util";

export type ImageType = {
  image?: string;
  checked?: string;
};

export type SubItem = {
  addOpt: number;
  cropName: string;
  harvestOpt: number;
  id: number;
  pid: number;
  sortNum: number;
  subsets: null | [];
} & ImageType;

export type PestItemType = {
  addOpt: number;
  cropName: string;
  harvestOpt: number;
  id: number;
  pid: number;
  sortNum: number;
  subsets: SubItem[];
} & ImageType;
//获取分类树结构
export function getDiseasePestTree() {
  return get<PestItemType[]>({
    baseURL: env.centerUrl,
    url: "/soil/diseasepest/typetree",
  });
}

/**
 * 病虫害列表
 *  */
export type IReqPest = PagingParameters & {
  type?: number | null;
  status?: number | null;
  name?: string | null;
  sort?: number | null;
  cropId?: number | null;
};

export type IResPest = {
  id?: number;
  name?: string;
  status?: number;
  type?: number;
  kindIds?: number[];
  kindNames?: string[];
  images?: string[];
  absolutePathImages?: string[];
  intro?: string;
  symptom?: string;
  prevent?: string;
  factor?: string;
  spread?: string;
  shape?: string;
  habit?: string;
  harm?: string;
};

// 列表
export function getPestList(data: IReqPest) {
  return get<WithPagingData<IResPest[]>>({
    baseURL: env.centerUrl,
    url: "/soil/diseasepest/list",
    data,
  });
}

export function getPestDetail(data: { id: number }) {
  return get<IResPest>({
    baseURL: env.centerUrl,
    url: "/soil/diseasepest/detail",
    data: data,
  });
}
